import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding: 10px 10px;
  width: 100%;
  @media (max-width: 600px){
    flex-direction: column;
    
  }
`;

export const WrapperHeaderDash = styled.div`
   space: 32px
`;

export const DashContainer = styled.div`
  background:#ffffff;
  border-radius: 4px;
  width: 100%;
  height: 40px;
  color: #000000;

  position: relative;

  display: flex;
  align-items: center;

  & + div{
      margin-top: 12px;
    }

  input{
    width: 22vw;
    flex: 1;
    background: transparent;
    border: 0;
    text-align: center;
      font-size: 12px;
      color: #000000;

    &::placeholder{
      text-align: center;
      font-size: 12px;
      color: #000000;
    }
  }

  span{
      font-size: 14px;
      color: var(--color-red);
      text-align: left;
      /* display: none; */
    }
`;

export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;

  margin: 10px 10px;
  
  @media (min-width: 600px){
    justify-content: space-between;
  }
  
  @media (max-width: 600px){
    flex-direction: column;
    
  }
`;

export const Img = styled.img`
  width: 180px;
  height: 80px;
  margin: 0 20px;
`;

export const User = styled.div`
    background-color: blue;
    color: white;
`;